<template>
   <div id="box" :switchLanguage="switchLanguage">
<!-- header 女媧商城 -->
<div class="header">
<!-- <img src="../../static/img/banner.png" alt=""> -->
<i class="backgroundImage"></i>
<div class="headerDivPo">
    <h4>{{ $t('homePageIntroducesHeaderStoreTop') }}</h4>
    <!-- <p>您能開發應用程式、故事、飾品等商品<br>並且，您的創意將被遍佈全國的孩子們使用</p> -->
    <p><span>{{ $t('homePageIntroducesHeaderchildTop')}}</span><br><span>{{$t('homePageIntroducesHeaderchildBot') }}</span></p>
</div>
</div>
<!-- banner 女媧開發者計畫 -->
<div class="banner">
  <div class="container">
      <h2>{{ $t('homePageIntroducesContentPlan') }}</h2>
<p class="p1" >{{ $t('homePageIntroducesContentPlanBot') }}</p>
<div class="row">
<div class="col-md-4 col-xs-4">
<div class="media">
  <div class="media-left">
    <a href="#">
      <img class="media-object" src="../../static/img/introduces/introduces_platform.png" alt="...">
    </a>
  </div>
</div>
</div>
<div class="col-md-8 col-xs-8">
 <div class="media-body">
    <strong class="media-heading ">{{ $t('homePageIntroducesContentPlatform') }}</strong>
    <p class="p2 mediaHeadingA">{{ $t('platformDeveloperProgram') }}</p>
   <!-- <p class="p2 mediaHeadingA"><span>{{ $t('homePageIntroducesContentPlatformContOne') }}</span><br><span>{{ $t('homePageIntroducesContentPlatformContTwo') }}</span><br><span>{{ $t('homePageIntroducesContentPlatformContThree') }}</span><br><span>{{ $t('homePageIntroducesContentPlatformContFour') }}</span></p> -->
  </div>
</div>
<hr>
</div>
<div class="row">
<div class="col-md-4 col-xs-4">
<div class="media">
  <div class="media-left">
    <a href="#">
      <img class="media-object" src="../../static/img/introduces/introduces_advanced.png" alt="...">
    </a>
  </div>
</div>
</div>
<div class="col-md-8 col-xs-8">
 <div class="media-body">
    <strong class="media-heading">{{ $t('homePageIntroducesContentAdvanced') }}</strong>
    <p class="p2 mediaHeadingB">{{ $t('AdvancedPevelopmentPartners') }}</p>
   <!-- <p class="p2 mediaHeadingB"><span>{{ $t('homePageIntroducesContentAdvancedContOne') }}</span><br><span>{{ $t('homePageIntroducesContentAdvancedContTwo') }}</span><br> -->
    <!-- <span>{{ $t('homePageIntroducesContentAdvancedContThree') }}</span><br><span>{{ $t('homePageIntroducesContentAdvancedContFour') }}</span></p> -->
  </div>
</div>
<hr>
</div>
<div class="row">
<div class="col-md-4 col-xs-4">
<div class="media">
  <div class="media-left">
    <a href="#">
      <img class="media-object" src="../../static/img/introduces/introduces_custom.png" alt="...">
    </a>
  </div>
</div>
</div>
<div class="col-md-8 col-xs-8">
 <div class="media-body">
    <strong class="media-heading">{{ $t('homePageIntroducesContentCustomized') }}</strong>
    <p class="p2 mediaHeadingC">{{ $t('customDevelopmentPartners') }}</p>
   <!-- <p class="p2 mediaHeadingC"><span>{{ $t('homePageIntroducesContentCustomizedContOne') }}</span><br><span>{{ $t('homePageIntroducesContentCustomizedContTwo') }}</span><br> -->
<!-- <span>{{ $t('homePageIntroducesContentCustomizedContThree') }}</span><br><span>{{ $t('homePageIntroducesContentCustomizedContFour') }}</span></p> -->
  </div>
</div>
</div>
  </div>
</div>
<!-- section 平台開發者計畫 -->
<div class="section">
<div class="container">
    <!-- <img src="../../static/img/introduces/invalid-name.png" alt=""> -->
    <img :src="src" alt="">
</div>
</div>
<div style="padding-top: 47px;padding-bottom: 142px;">
    <div class="img-img" @click="becomeDeveloperBtn">
        <div class="h5">{{ $t('registerTitle') }}</div>
    </div>
</div>
  <!-- footer 準則與資源 -->
<div class="footer">
   <img src="../../static/img/introduces/introduces_footer_one.png" class="footerImageA" alt="...">
  <div class="footerDiv">
   <h5>{{ $t('homePageIntroducesBottomGuidelines') }}</h5>
   <h6>{{ $t('homePageIntroducesBottomAbout') }}</h6>
        <div class="boxes" @click="viewRulesBtn">
             <span class="watchRules">{{ $t('homePageIntroducesBottomWatch') }}</span> 
        </div>
  </div>
   <img src="../../static/img/introduces/introduces_footer_two.png" class="footerImageB" alt="...">
</div>
<BackTop/>
 <!-- <img class="img-foot" src="../../static/img/footer4.png" style="width: 100px;height: 100px;float: right;margin-right: 50px;margin-bottom: 50px;margin-top: -136px;" alt=""> -->
  </div>
</template>
<script>
import BackTop from './views/BackTop.vue'
export default {
    data () {
        let protocol = window.location.protocol
        let splitLine = '//'
        let env = window.location.hostname
        let path = protocol + splitLine + env
        return {
            src: '',
            base: path,
            path: '',
            env: env,
            baseUrl: '/developerUser',
            frontPort: '8080'
        }
    },
    components: {
        BackTop
    },
    methods: {
        becomeDeveloperBtn () {
            if (sessionStorage.registeredDetail && localStorage.token) {
                this.$router.push({name: 'newIndex'})
                this.$store.state.borderStyle = null
                localStorage.setItem('clickState', null)
            } else {
                if (this.$store.state.borderStyle === 'login') {
                    this.env === 'localhost' ? this.path = this.base + ':' + this.frontPort + this.baseUrl + '/login' : this.path = this.base + this.baseUrl + '/login'
                    window.location.href = this.path
                } else {
                    this.$store.state.borderStyle = 'login'
                    localStorage.setItem('clickState', 'login')
                }
            }
        },
        viewRulesBtn () {
            this.$store.state.borderStyle = 'file'
            localStorage.setItem('clickState', 'file')
            this.$router.push({name: 'listApp'})
        }
    },
    computed: {
        switchLanguage () {
            let lang = this.$store.state.switchLanguage
            if (lang === 'zh-TW') {
                this.src = require('../../static/img/introduces/invalid-name.png')
            } else if (lang === 'zh-CN') {
                this.src = require('../../static/img/sdk/invalid_cn.png')
            } else {
                this.src = require('../../static/img/sdk/invalid_en.png')
            }
            return this.$store.state.switchLanguage
        }
    }
}
</script>
<style scoped>
* {
  margin: 0 auto;
  padding: 0;
  color: #333;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  object-fit: contain;
  font-family: sans-serif;
}
.media:first-child{
  float: right;
}
.backgroundImage{
  display: block;
  /* width: 1000px; */
  /* height: 300px; */
  background-image: url('../../static/img/introduces/introduces_banner.png');
  /* background-size:100% 100%; */
  width: 100%;
  height: 0px;
  padding-top: 50.2%;
  position: relative;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  /* background-image: url(/91a3a79….png); */
}
.footerImageA{
    position: absolute;
    left: 16%;
    top: 11%;
}
.footerImageB{
    position: absolute;
    top: 16.4%;
    /* right: 17%;  */
    right: 15.6%; 
}
.developerPlan{
    text-align: center;
}
#box {
  height: 100%;
  position: relative;
}
.mediaHeadingC{
    padding-bottom: 118px;
}
.mediaHeadingB{
    padding-bottom: 38px;
}
.mediaHeadingA{
    padding-bottom: 42px;
}
/* header 女媧商城  */
.header {
  margin-top: -8px;
  position: relative;
}
.headerDivPo {
  position: absolute;
  top: 32.4%;
}
.header img {
  width: 100%;
}
h4 {    
  width: 562px;
  height: 118px;
  font-size: 40px;
  font-weight: 550;
  letter-spacing: 2.2px;
  padding-left: 54px;
  /* margin-top: -454px; */
  margin-bottom: 25px;
  color: rgba(51, 51, 51, 0.9);
}
p {
  /* width: 502px; */
  /* height: 66px; */
  font-size: 22px;
  font-weight: 300;
  letter-spacing: 1.2px;
  padding-left: 56px;
  line-height: 34px;
  letter-spacing: 1.2px;
  margin: 0px;
}
/* banner 女媧開發者計畫 */
.banner {
  /* width: 1440px; */
  /* height: 1170px; */
  background-color: rgb(229, 251, 252);
  margin-top: -10px;
}
h2 {
  /* height: 59px; */
  margin-top: 123px;
  text-align: center;
  margin-bottom: 14px;
  font-size: 40px;
  font-weight: 300;
  letter-spacing: 2.2px;
}
.p1 {
  margin-bottom: 129px;
  height: 28px;
  font-size: 22px;
  font-weight: 300;
  letter-spacing: 1.2px;
  text-align: center;
}
.media-object {
  width: 150px;
  height: 150px;
  /* margin-left: 128px; */
  margin-bottom: 53px;
  margin-right: 85px;
}
hr {
  /* width: 1246px; */
  width: 93%;
  border: solid 1.2px rgba(0, 224, 218, 0.5);
  margin-bottom: 53px;
}
.media-heading strong {
  height: 28px;
  font-size: 22px;
  font-weight: 500;
  margin-bottom: 15px;
  letter-spacing: 1.2px;
}
.media-heading{
  width: 246px;
  height: 28px;
  font-family: sans-serif;
  font-size: 22px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.2px;
  color: var(--black);
}
.p2 {
  /* height: 132px; */
  width: 87%;
  letter-spacing: 1.2px;
  padding-left: 0px;
  font-size: 22px;
  font-weight: 300;
  margin-top: 11px;
  text-align: justify;
  /* margin-bottom: 60px; */
}
/* section 平台開發者計畫 */
.section {
  width: 1042px;
  height: 100%;
  background-color: #fff;
}
.section img {
  /* width: 100%; */
  margin-top: 105px;
}
h5 {
  font-size: 22px;
  font-weight: 300;
  letter-spacing: 1.2px;
  margin-bottom: 15px;
  margin-top: 15px;
  margin-left: 12px;
}
.table-bordered {
  border: 0px;
}
.table {
  width: 876px;
  height: 100px;
  margin-left: -170px;
  margin-top: 50px;
}
td {
  width: 400px;
  height: 80px;
  border: solid 5px rgba(0, 224, 218, 0.3);
  border-top-style: none;
  border-left-style: none;
  text-align: center;
}
th {
  width: 400px;
  height: 80px;
  border: solid 5px rgba(0, 224, 218, 0.3);
  border-bottom: none;
  border-left: none;
  text-align: center;
}
.td-img {
  text-align: center;
  height: 48px;
}
.left-h3 img {
  width: 150px;
  height: 150px;
  margin-left: 22px;
  margin-bottom: 10px;
}
.left-h3 h3 {
  height: 38px;
  font-size: 22px;
  letter-spacing: 1.2px;
  margin-top: -60px;
  margin-left: 10px;
  width: 172px;
  text-align: center;
}
.img-img {
  width: 430px;
  height: 78px;
  border-radius: 10px;
  border: solid 3px rgba(0, 181, 226, 0.5);
  background-repeat: no-repeat;
  margin: auto;
  cursor: pointer;
}
.h5 {
  height: 62px;
  line-height: 52px;
  color: #00b5e2;
  margin-top: 10px;
  font-size: 22px;
  font-weight: bold;
  letter-spacing: 1.2px;
  text-align: center;
}
/* footer 準則與資源  */
.footer {
  /* width: 1440px; */
  height: 286px;
  background-image: radial-gradient(circle at 50% 50%, #ffc759, #ffb859);
  clear: right;
  margin-bottom: -1px;
  position: relative;
}
.footer h5 {
  /* margin-top: -112px; */
  font-weight: 300;
  letter-spacing: 1.2px;
  text-align: center;
  margin: auto;
  padding-top: 58px;
  padding-bottom: 16px;
}
.footer h6 {
  width: 460px;
  height: 62px;
  font-weight: 300;
  letter-spacing: 0.8px;
  /* text-align: center; */
  font-size: 14px;
  margin-left: 590px;
  margin: auto;
  text-align: center;
}
.watchRules {
  height: 62px;
  line-height: 42px;
  /* margin-left: 160px; */
  width: 117px;
  height: 33px;
  font-size: 22px;
  font-weight: bold;
  letter-spacing: 1.2px;
  text-align: center;
  color: #fff;
}
.boxes {
  /* width: 460px; */
  /* width: 460px; */
  width: 32%;
  height: 50px;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.3);
  border: solid 2.5px #fff;
  margin-bottom: 65px;
  margin-left: 560px;
  margin: auto;
  cursor: pointer;
  text-align: center;
}
.img4 {
  height: 100px;
  float: right;
  margin-top: -200px;
  padding-right: 90px;
  margin-right: -95px;
}
.img-footer {
  width: 100px;
  height: 100px;
  float: right;
  margin-top: 400px;
  margin-bottom: -50px;
  margin-right: -200px;
  position: relative;
}

</style>



// WEBPACK FOOTER //
// Introduces.vue?547afbbc